package de.oevbs.kunde.kundenportal2.services.authentication.store

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.authentication.PortalSession
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.GlobalServiceMessagesStore
import de.oevbs.kunde.kundenportal2.components.globalSubmitTracker
import de.oevbs.kunde.kundenportal2.model.services.authentication.PartnerAuthentication
import de.oevbs.kunde.kundenportal2.services.authentication.PartnerAuthenticationClient
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import dev.fritz2.core.Handler
import dev.fritz2.core.invoke
import dev.fritz2.core.storeOf
import dev.fritz2.headless.validation.ComponentValidationMessage
import dev.fritz2.validation.ValidatingStore
import dev.fritz2.validation.valid
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

/**
 * Wird als Objekt angelegt, weil die Success Message Page während einer gesamten Session erhalten bleiben muss.
 * Um nach dem Logout den Step zu resetten und Daten von ggf. anderen Benutzern am selben PC zu löschen,
 * wird der PortalSession.onLogout Notifier genutzt.
*/
object PartnerAuthenticationStore :
    ValidatingStore<PartnerAuthentication, Unit, ComponentValidationMessage>(
        initialData = PartnerAuthentication(),
        validation = PartnerAuthentication.validation,
        metadataDefault = Unit,
        validateAfterUpdate = false,
        job = Job()
    ) {

    private val client = PartnerAuthenticationClient().use(PortalSessionMiddleware)

    private val progressStore = storeOf(GeneralProgressStep.SUBMIT1, job)
    val currentStep: Flow<GeneralProgressStep> = progressStore.data

    private val headerText = storeOf("Freischaltcode für Vertragsverknüpfung anfordern", job)
    val header: Flow<String> = headerText.data

    val submitAuthentication: Handler<Unit> = handle { authentication ->
        GlobalServiceMessagesStore.clear()

        if (!validate(authentication).valid) {
            return@handle authentication
        }

        val success = globalSubmitTracker.track {
            checkPolicyData(authentication)
        }

        if (!success) return@handle authentication

        //Erfolgsmeldung anzeigen - Code-Fenster kommt erst nach erneutem Einloggen.
        //Der Kunde erhält den Code erst in einigen Tagen. Dieses Stepping wird nur beim Logout zurückgesetzt.
        progressStore.update(GeneralProgressStep.SUCCESS2)
        PartnerAuthentication()
    }

    init {
        PortalSession.onLogout {
            update(PartnerAuthentication())
            progressStore.update(GeneralProgressStep.SUBMIT1)
        }
    }

    private suspend fun checkPolicyData(partnerAuthentication: PartnerAuthentication): Boolean {
        tryCatchAndHandleErrors("Schritt 1 der PartnerAuthentifizierung") {
            client.partnerAuthenticate(partnerAuthentication)
        } ?: return false

        return true
    }
}